(function () {
  // Hardcoded to match products_per_page in static-search.liquid /
  // static-collection.liquid (default 36). If those ever diverge, read
  // from a data attribute on the grid instead.
  var PAGE_SIZE = 36;

  // --- Infinite-scroll hack -------------------------------------------------
  // Instead of a separate infinite-scroll fetch path, we keep the existing
  // "Load More" button (and all its loading / dedup / has-more guards) and
  // just auto-click it when it scrolls into view, after a short delay, so it
  // behaves like infinite scroll. Set AUTO_SCROLL to false to fall back to a
  // plain click-to-load button.
  var AUTO_SCROLL = true;
  var AUTO_CLICK_DELAY = 350; // ms — small pause so it feels natural
  // No pre-load margin: only auto-click once the button has actually scrolled
  // into the viewport (combined with AUTO_SCROLL_THRESHOLD below, which
  // requires the button to be fully visible). Using a positive rootMargin here
  // fires while the button is still below the fold, so the page jumps before
  // the user even sees the button.
  var AUTO_SCROLL_ROOT_MARGIN = '0px';
  // Fraction of the button that must be visible before auto-clicking. 1.0 =
  // fully in view. The button is short, so requiring 100% is safe.
  var AUTO_SCROLL_THRESHOLD = 1.0;
  var autoScrollObserver = null;
  var autoScrollButton = null;
  var autoClickTimer = null;

  function clearAutoClickTimer() {
    if (autoClickTimer) {
      clearTimeout(autoClickTimer);
      autoClickTimer = null;
    }
  }

  // Re-deliver the button's current intersection state. IntersectionObserver
  // only fires on transitions, so after an auto-click that reveals/fetches a
  // batch WITHOUT pushing the button out of view (e.g. revealing 12 items on a
  // short Show=12 grid), it would otherwise go quiet and stall. Re-observing
  // forces a fresh callback: if the button is still fully in view we keep
  // loading; if it has moved out we simply wait for the next scroll.
  function rearmAutoScroll() {
    if (!AUTO_SCROLL || !autoScrollObserver || !autoScrollButton) return;
    autoScrollObserver.unobserve(autoScrollButton);
    autoScrollObserver.observe(autoScrollButton);
  }

  function canAutoClick(button) {
    return button
      && button.style.display !== 'none'
      && !button.disabled
      && !button.classList.contains('loading');
  }

  // Watch the (current) Load More button; when it enters the viewport, fire a
  // synthetic click after AUTO_CLICK_DELAY. Re-arms on every bind because the
  // button is cloned-and-replaced in bindLoadMore.
  function observeForAutoClick(button) {
    if (!AUTO_SCROLL || !('IntersectionObserver' in window)) return;

    if (autoScrollObserver) autoScrollObserver.disconnect();
    clearAutoClickTimer();

    autoScrollObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          clearAutoClickTimer();
          return;
        }
        if (!canAutoClick(button)) return;
        clearAutoClickTimer();
        autoClickTimer = setTimeout(function () {
          autoClickTimer = null;
          if (canAutoClick(button)) button.click();
        }, AUTO_CLICK_DELAY);
      });
    }, { rootMargin: AUTO_SCROLL_ROOT_MARGIN, threshold: AUTO_SCROLL_THRESHOLD });

    autoScrollButton = button;
    autoScrollObserver.observe(button);
  }

  function findGrid() {
    return document.querySelector('[data-globo-filter-items]')
      || document.querySelector('.collection-page__product-list');
  }

  // Does the live pagination currently advertise a next page? We don't trust
  // the href value any more, just its presence as a "more pages remain" flag.
  function hasMorePagesLive() {
    return !!document.querySelector('.collection-page .pagination .next a');
  }

  // Are there products in the grid that applyLimit hid? Those are products
  // that were already fetched (e.g. by Show=24's auto-fetch) but then
  // hidden when the user dropped Show back down to 12. LM should reveal
  // them before going back to the network for more pages.
  function hiddenItemsInGrid() {
    var grid = findGrid();
    if (!grid) return [];
    var hidden = [];
    grid.querySelectorAll('.product-item').forEach(function (item) {
      if (item.style.display === 'none') hidden.push(item);
    });
    return hidden;
  }

  function hasMorePagesIn(doc) {
    return !!doc.querySelector('.collection-page .pagination .next a');
  }

  // The next page to fetch is derived from how many products are already in
  // the grid — counting whatever's in DOM (including hidden ones from
  // applyLimit) divided by PAGE_SIZE, plus one. This is self-correcting:
  // - Initial render: grid has 12 → next page = 2.
  // - After Show=24 auto-fetch: grid has 24 → next page = 3.
  // - After a Load More click: grid has 24 → next page = 3.
  // - After Show=24 then Show=12 (no new fetch, just hides extras): grid
  //   still has 24 → next page = 3.
  // Previously the page number lived in a closure variable seeded from
  // URL ?page= (which is always 1 in our app, since neither Show nor
  // Load More pushState a page param). That meant LM kept re-fetching
  // page 2, dedup wiped everything, anyAppended ended up false, and the
  // success handler hid the button — exactly the disappearance the
  // user has been reporting.
  function nextPageToFetch() {
    var grid = findGrid();
    if (!grid) return 2;
    var count = grid.querySelectorAll('.product-item').length;
    return Math.floor(count / PAGE_SIZE) + 1;
  }

  // Build the fetch URL for the next page by starting from the address-bar
  // URL (which carries every active filter / sort / q param) and pinning
  // page=N. This is the key fix: it stops us inheriting whatever Shopify
  // chose to put in the rendered next-link href, which on metafield filters
  // came back as a relative ?page=N that wiped the filter when resolved.
  //
  // /search vs collection routing matches buildFetchAndDisplay() in
  // custom-collection-filter.js: when q is present we route to /search
  // (because the display URL stays on /collections/<handle> but the fetch
  // target needs to hit Shopify's search engine).
  function buildPageFetchUrl(pageNum) {
    var u = new URL(window.location.href);
    var q = (u.searchParams.get('q') || '').trim();

    if (q) {
      var sp = new URLSearchParams();
      sp.set('q', q);
      sp.set('type', 'product');
      u.searchParams.forEach(function (val, key) {
        if (key === 'q' || key === 'type' || key === 'page') return;
        sp.append(key, val);
      });
      if (pageNum > 1) sp.set('page', String(pageNum));
      return '/search?' + sp.toString();
    }

    u.searchParams.delete('page');
    if (pageNum > 1) u.searchParams.set('page', String(pageNum));
    return u.toString();
  }

  // Build a Load More button from scratch when the page never rendered one
  // at all — happens when a search/filter result fits within a single page
  // (paginate.next was false), so Liquid omitted the .infinite-scroll markup
  // entirely. If the Show dropdown is then set below the total result count,
  // applyLimit() hides the extras but there is no button in the DOM to
  // reveal them with. hiddenItemsInGrid() (checked by the caller) is what
  // tells us that's the situation we're in.
  function createLoadMoreButton() {
    // Final check right before inserting: bindLoadMore runs more than once per
    // action (an early pass and a later, promise-deferred pass), and both can
    // reach here believing no button exists yet if a second one was created
    // in between. Re-querying immediately before the DOM write closes that gap.
    var existing = document.querySelector(
      '.collection-page .infinite-scroll__show-more, .collection-page .infinite-scroll__loading'
    );
    if (existing) return existing;

    var main = document.querySelector('.collection-page__layout-main') || document.querySelector('.collection-page');
    if (!main) return null;
    var wrap = document.createElement('div');
    wrap.className = 'infinite-scroll';
    wrap.setAttribute('data-infinite-scroll-target', '');
    var button = document.createElement('button');
    button.className = 'infinite-scroll__loading infinite-scroll__show-more';
    // Matches locales/en.default.json's collections.more / collections.loading,
    // which currently hold the same string.
    var label = 'Loading more…';
    button.setAttribute('data-infinite-scroll-show-more', label);
    button.setAttribute('data-infinite-scroll-loading', label);
    button.textContent = label;
    wrap.appendChild(button);

    // Insert right after the product grid — never at the end of
    // .collection-page__layout-main, which would land it below the
    // collection's SEO text / post-grid rich text instead of directly
    // under the products.
    var grid = findGrid();
    if (grid && grid.parentNode) {
      grid.insertAdjacentElement('afterend', wrap);
    } else {
      main.appendChild(wrap);
    }
    return button;
  }

  function bindLoadMore() {
    // Defensive: collapse every element that looks like our Load More button
    // down to exactly one survivor, then normalize its classes. bindLoadMore
    // runs more than once per action (an early synchronous pass before
    // applyLimit hides anything, and a later pass once it has) and can also
    // overlap with a second in-flight search/filter request — separate passes
    // can each independently believe no button exists yet and each create
    // their own, leaving duplicates (sometimes missing a class, and so
    // missing the border/uppercase styling that class drives).
    var candidates = Array.prototype.slice.call(
      document.querySelectorAll('.collection-page .infinite-scroll__show-more, .collection-page .infinite-scroll__loading')
    );
    var button = candidates.shift();
    candidates.forEach(function (extra) {
      var wrap = extra.closest('.infinite-scroll');
      (wrap || extra).remove();
    });
    // Also drop any wrapper left empty by the removals above.
    document.querySelectorAll('.collection-page .infinite-scroll').forEach(function (wrap) {
      if (!wrap.querySelector('.infinite-scroll__show-more, .infinite-scroll__loading')) wrap.remove();
    });
    if (button) {
      // Whichever element survived, make sure it actually carries both
      // classes — a stray element with only one would render unstyled
      // (no border, no uppercase) even though it looks like our button.
      button.classList.add('infinite-scroll__loading', 'infinite-scroll__show-more');
    }

    if (!button) {
      // Build a button whenever there's something to reveal, whether that's
      // CSS-hidden items already fetched (Show dropped below the total) OR
      // genuine additional server pages. The latter case only happens via
      // this fallback: /search (products_pagination_method: traditional_pagination
      // in search.json) never renders our infinite-scroll markup at all,
      // however many pages of results it has — Shopify's own numbered
      // pagination is the only thing in a fetched /search response, and
      // without this it silently becomes the only way to page through.
      if (hiddenItemsInGrid().length === 0 && !hasMorePagesLive()) return;
      button = createLoadMoreButton();
      if (!button) return;
    }

    // Clone-and-replace so we never inherit a prior click listener and
    // also wipe any inline style="display:none" left over from a stale
    // state (so the button reappears whenever bindAll runs and the live
    // pagination still has a .next a).
    var fresh = button.cloneNode(true);
    fresh.style.display = '';
    // cloneNode also copies a stale loading/disabled state. That happens when
    // bind() runs while a previous fetch is still in flight (e.g. switching
    // Show=12 right after Show=36 auto-clicked Load More): the in-flight fetch
    // resets the OLD, now-detached button, leaving this clone stuck in
    // "loading"/disabled forever so every later click bails at the guard and
    // the button just sits reading "Loading more…". Always start clean.
    fresh.classList.remove('loading');
    fresh.disabled = false;
    button.parentNode.replaceChild(fresh, button);
    button = fresh;

    if (!findGrid()) return;

    // Show LM whenever there's something to reveal — either more server
    // pages OR hidden products already in the grid waiting to be shown.
    // Previously we hid LM the moment .pagination .next a was gone, which
    // wiped the button even when applyLimit had stashed 12 products
    // under display:none from an earlier Show=24 auto-fetch.
    if (!hasMorePagesLive() && hiddenItemsInGrid().length === 0) {
      button.style.display = 'none';
      if (autoScrollObserver) autoScrollObserver.disconnect();
      clearAutoClickTimer();
      return;
    }

    button.setAttribute('type', 'button');
    var loadingText = button.getAttribute('data-infinite-scroll-loading') || 'Loading...';
    var showMoreText = button.getAttribute('data-infinite-scroll-show-more') || button.textContent.trim();
    // Reset to the resting label in case the clone carried stale loading text.
    button.textContent = showMoreText;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (button.classList.contains('loading') || button.disabled) return;

      // If applyLimit hid some products earlier (Show=24 then Show=12),
      // reveal a batch of those first before going back to the network.
      // Batch size = current Show value, so each click expands the
      // visible grid by one "page" worth.
      var hidden = hiddenItemsInGrid();
      if (hidden.length > 0) {
        var limitSel = document.querySelector('[data-cf-limit]');
        var batch = parseInt(limitSel && limitSel.value, 10) || 12;
        for (var i = 0; i < batch && i < hidden.length; i++) {
          hidden[i].style.display = '';
        }
        // After revealing, decide whether to keep the button visible.
        if (!hasMorePagesLive() && hiddenItemsInGrid().length === 0) {
          button.style.display = 'none';
        } else {
          // Keep infinite scroll going: revealing a batch may not have pushed
          // the button out of view, so re-arm to re-check its visibility.
          rearmAutoScroll();
        }
        return;
      }

      if (!hasMorePagesLive()) {
        button.style.display = 'none';
        return;
      }

      var nextPage = nextPageToFetch();
      var fetchUrl = buildPageFetchUrl(nextPage);

      button.classList.add('loading');
      button.disabled = true;
      button.textContent = loadingText;

      fetch(fetchUrl, { cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var fetchedGrid = doc.querySelector('[data-globo-filter-items]')
            || doc.querySelector('.collection-page__product-list');
          if (!fetchedGrid) throw new Error('No grid in fetched HTML');

          var grid = findGrid();
          if (!grid) throw new Error('No live grid');

          // De-dupe by data-product-item-id — defensive against any
          // cache/echo scenario sending back already-rendered items.
          var existingIds = {};
          grid.querySelectorAll('.product-item[data-product-item-id]').forEach(function (item) {
            existingIds[item.getAttribute('data-product-item-id')] = true;
          });

          var fetchedItems = Array.prototype.slice.call(
            fetchedGrid.querySelectorAll('.product-item')
          );
          fetchedItems.forEach(function (item) {
            var id = item.getAttribute('data-product-item-id');
            if (id && existingIds[id]) return;
            grid.appendChild(item);
            if (id) existingIds[id] = true;
          });

          // Authoritative "are there more pages?" check uses the fetched
          // response itself — that's the freshest source of truth for
          // whether page N+1 exists. Replace the live pagination so
          // subsequent renders / re-binds see the right state.
          var stillMore = hasMorePagesIn(doc);
          var fetchedPagination = doc.querySelector('.collection-page .pagination');
          var livePagination = document.querySelector('.collection-page .pagination');
          if (fetchedPagination && livePagination) {
            livePagination.replaceWith(fetchedPagination);
          } else if (livePagination && !fetchedPagination) {
            livePagination.remove();
          }
          // Kept only as hasMorePagesLive()'s internal signal — never user-facing.
          if (fetchedPagination) fetchedPagination.style.display = 'none';

          // Only hide the button when there genuinely are no more pages.
          // (Previously we also hid when anyAppended was false — but that
          // mis-fired when dedup wiped the fetch's products, e.g. when LM
          // refetched a page that had already been loaded by Show=24's
          // auto-fetch, leaving the button gone and the user stuck.)
          if (stillMore) {
            button.classList.remove('loading');
            button.disabled = false;
            button.textContent = showMoreText;
            // Re-check visibility in case the appended page didn't move the
            // button out of view, so infinite scroll keeps going.
            rearmAutoScroll();
          } else {
            button.style.display = 'none';
          }

          if (window.Rimg && typeof window.Rimg.init === 'function') {
            window.Rimg.init();
          }
        })
        .catch(function () {
          button.classList.remove('loading');
          button.disabled = false;
          button.textContent = showMoreText;
        });
    });

    // Turn the button into infinite scroll: auto-click it when it reaches the
    // viewport. Only reached when there's genuinely more to load (the early
    // returns above bail before this for the "nothing left" case).
    observeForAutoClick(button);
  }

  window.CFLoadMore = { bind: bindLoadMore };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLoadMore);
  } else {
    bindLoadMore();
  }
})();
